export { default as BrowserNotificationsHandler } from './BrowserNotificationsHandler';
